import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Swiper, { Navigation } from 'swiper';
import { formatImage } from '@src/common/formatImage';

Swiper.use([Navigation]);

class LongImages extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    state = {
        currentIndex: 0,
    };

    componentDidMount() {
        new Swiper('#swiper8', {
            direction: 'vertical',
            slidesPerView: 4,
            navigation: {
                prevEl: '.prev8',
                nextEl: '.next8',
            },
        });
    }

    setCurrentIndex = index => {
        this.setState({
            currentIndex: index,
        });
    };

    render() {
        const { content } = this.props;
        const { currentIndex } = this.state;

        return (
            <div className={styles.container}>
                <div className={styles.left}>
                    <div className="swiper" id="swiper8">
                        <div className="swiper-wrapper">
                            {content.map((item, index) => {
                                return (
                                    <div className="swiper-slide" key={index}>
                                        <div
                                            className={`${styles.swiperItem} ${
                                                currentIndex === index ? styles.active : ''
                                            }`}
                                            onClick={() => this.setCurrentIndex(index)}>
                                            <img src={formatImage(item.image, 280, 161)} alt={item.title} />
                                            <div className={styles.text}>
                                                <a href={item.url} target="_blank" rel="noreferrer">
                                                    {item.title}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className={styles.navigation}>
                        <div className={`prev8 ${styles.prev8}`} />
                        <div className={`next8 ${styles.next8}`} />
                    </div>
                </div>
                <div className={styles.right}>
                    <a href={content[currentIndex].url} target="_blank" rel="noreferrer">
                        <img src={content[currentIndex].longImage} alt={content[currentIndex].title} />
                    </a>
                </div>
            </div>
        );
    }
}

export default errorBoundary(LongImages);
